var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.55665,
    height: 9.55665,
    fill: "#F25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10.4434,
    width: 9.55665,
    height: 9.55665,
    fill: "#01A4EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4434,
    width: 9.55665,
    height: 9.55665,
    fill: "#7FBA00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4434,
    y: 10.4434,
    width: 9.55665,
    height: 9.55665,
    fill: "#FFB901"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/Microsoft_Logo.38751db25e98d9350012f2335a813b0d.svg";
export { ForwardRef as ReactComponent };